export default __webpack_public_path__ + "static/media/misc-books3-768w.e1ef53df.avif";